<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner2.jpg`"
      ></BannerTopMobile>
    </div>
    <v-container class="mt-5">
      <v-row v-if="products.length">
        <v-col class="text-center">
          <h1 class="color-blue font-backward">
            Búsqueda de productos
          </h1>
        </v-col>
      </v-row>

      <div class="d-none d-sm-none d-md-block">
        <v-row>
          <v-col class="text-center">
            <v-row :key="products.length" v-if="products.length">
              <v-col
                cols="12"
                xl="4"
                lg="4"
                md="6"
                sm="12"
                v-for="(item, index) in products"
                :key="index"
                class="mb-10"
              >
                <ItemSlideFlavor
                  @addCart="openSnack"
                  :active="false"
                  :item="item"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="text-center">
                <h1 class="mt-5 color-blue font-backward">
                  No hay resultados para esta búsqueda
                </h1>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <!--moviles-->
      <div class="d-block d-sm-block d-md-none pb-5" v-if="products.length">
        <v-sheet
          class="mx-auto"
          elevation="0"
          width="400"
          color="light"
        >
          <v-slide-group
            v-model="slide"
            class="pa-4"
            center-active
          >
            <v-slide-item
              v-for="(item, index) in products"
              :key="index"
              class="mr-4"
            >
              <ItemFlavorMobile
                @addCart="openSnack"
                :active="false"
                :item="item"
              />
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </div>

    </v-container>

    <SnackbarCart ref="snackbarCart"/>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

  </div>
</template>

<script>
import HomeService from '@/services/home.service'
import ItemSlideFlavor from '@/components/store/ItemSlideFlavor'
import ItemFlavorMobile from '@/components/store/mobile/ItemFlavorMobile'
//import { mapState } from 'vuex'

export default {
  components: { ItemSlideFlavor, ItemFlavorMobile },
  data() {
    return {
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      slide: null,
      products: [],
      overlay: false
    }
  },
  watch: {
    '$route.quuery.q': {
      handler() {
        this.getProducts()
      },
      deep: true
    }
  },
  methods: {
    openSnack() {
      this.$refs.snackbarCart.open()
    },
    async getProducts() {
      try {
        if (this.$route.query.q) {
          this.overlay = true
          let search = this.$route.query.q
          const { data:res } = await HomeService.getProductsBySearch(search)
          this.products = res
          this.overlay = false
        } else {
          this.$router.go(-1)
        }
      } catch (error) {
        this.overlay = false
      }
    }
  },
  mounted() {
    this.getProducts()
  }
}
</script>
